import { PhoneForwarded, UserPlus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useUIStore } from '@/stores/useUIStore'
import { useCallStore } from '@/stores/useCallStore'
import { TransferPanel } from './TransferPanel'

/**
 * Modale de transfert d'appel — wrappe `TransferPanel` (3 onglets) dans un
 * Dialog. Ouverte via `useCallStore.setShowTransferModal(true)` depuis
 * `InCallPanel` ou `PdCallBar`.
 *
 * Le widget flottant utilise le même `TransferPanel` inline (mode compact).
 */
export function TransferCallModal() {
  const { t } = useTranslation()
  const darkMode = useUIStore((s) => s.darkMode)
  const showTransferModal = useCallStore((s) => s.showTransferModal)
  const isTransferring = useCallStore((s) => s.isTransferring)
  const setShowTransferModal = useCallStore((s) => s.setShowTransferModal)
  // « Ajouter » opens the same window to bring someone into the call.
  const ajout = useCallStore((s) => s.transferMode === 'add')

  const close = () => {
    if (isTransferring) return
    setShowTransferModal(false)
  }

  return (
    <Dialog open={showTransferModal} onOpenChange={close}>
      <DialogContent
        className={cn(
          'max-w-md p-0 gap-0',
          darkMode && 'bg-slate-800 border-slate-700',
        )}
      >
        <DialogHeader
          className={cn(
            'px-6 pt-6 pb-4 border-b',
            darkMode ? 'border-slate-700' : 'border-slate-200',
          )}
        >
          <DialogTitle
            className={cn(
              'text-xl font-semibold flex items-center gap-2',
              darkMode && 'text-slate-100',
            )}
          >
            {ajout ? (
              <UserPlus className="h-5 w-5 text-blue-600" />
            ) : (
              <PhoneForwarded className="h-5 w-5 text-blue-600" />
            )}
            {ajout ? t('phone.ajout.title', "Ajouter à l'appel") : t('phone.transfer.title', "Transférer l'appel")}
          </DialogTitle>
        </DialogHeader>

        <div className="p-6">
          {/* key: the tabs start over between Transfer and Add */}
          <TransferPanel key={ajout ? 'add' : 'transfer'} darkMode={darkMode} onTransferred={close} ajout={ajout} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
